import { IDeductionRepository, IResetApprovalWorkflowRepositoryParams } from "@/core/repositories/deduction";

export class ResetApprovalWorkflowUseCase {
  constructor(private readonly deductionRepository: IDeductionRepository) {}

  async execute(params: IResetApprovalWorkflowRepositoryParams) {
    const response = await this.deductionRepository.resetApprovalWorkflow(params);

    return response;
  }
}
